/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorVersion = zod
	.object({
		end_date: zod.iso.datetime({ offset: true }).nullable().describe('Version end timestamp'),
		id: zod.uuid().describe('PraetorVersion ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Insertion timestamp'),
		is_draft: zod.boolean().describe('Whether this version is the current draft'),
		note: zod.string().nullable().describe('Deploy note'),
		praetor_id: zod.uuid().describe('Praetor ID'),
		start_date: zod.iso.datetime({ offset: true }).describe('Version start timestamp'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
	})
	.describe('An immutable praetor version snapshot');

export type PraetorVersion = zod.input<typeof PraetorVersion>;
export type PraetorVersionOutput = zod.output<typeof PraetorVersion>;
